import { ChartType } from '@principle-theorem/reporting/interfaces';
import { BaseChart } from './base-chart';
import { ChartOptions, type IChartData } from './chart-builder';

export class TableChart extends BaseChart {
  data: IChartData = {
    type: ChartType.Table,
    options: ChartOptions.init({
      legend: { position: 'none' },
    }),
  };
}
